// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"w1-z","colorTextValue":"x1-z","swatches":"y1-z","collapseLink":"z1-z","isCollapsed":"A1-z","dropdown":"B1-z","disabled":"C1-z"};